import { PlayerSizesTypes } from '../../../../common/store/store.types';
import { isEmpty } from '../../../../common/utils/utils';

interface StylesObject {
  logoWrapperStyle: {
    small: { [key: string]: any };
    medium: { [key: string]: any };
    large: { [key: string]: any };
    extraLarge: { [key: string]: any };
    hide: { [key: string]: any };
  } & any;
  logoStyle: { [key: string]: any };
}

const logoWrapper = {
  display: 'block',
  hide: {
    display: 'none',
  },
  small: {
    display: 'none',
  },
  medium: {
    maxWidth: '42px',
    maxHeight: '18px',
    marginLeft: '6px',
  },
  large: {
    maxWidth: '42px',
    maxHeight: '18px',
    marginLeft: '6px',
  },
  extraLarge: {
    maxWidth: '54px',
    maxHeight: '24px',
    marginLeft: '16px',
  },
  logoLink: {
    cursor: 'pointer',
  },
};

const logo = {
  display: 'flex',
  width: '100%',
  height: '100%',
};

export const getBrandLogoStyleObject = (showLogo: boolean, playerSize: PlayerSizesTypes, brandingLogoUrl: string): StylesObject => {
  const smallSize = playerSize === 'small';
  const mediumSize = playerSize === 'medium';
  const largeSize = playerSize === 'large';
  const extraLargeSize = playerSize === 'extraLarge';
  const isBrandingLogoLink = !isEmpty(brandingLogoUrl);

  return ({
    logoWrapperStyle: [
      logoWrapper,
      smallSize && logoWrapper.small,
      mediumSize && logoWrapper.medium,
      largeSize && logoWrapper.large,
      extraLargeSize && logoWrapper.extraLarge,
      !showLogo && logoWrapper.hide,
      isBrandingLogoLink && logoWrapper.logoLink,
    ],
    logoStyle: {
      ...logo,
    },
  });
};
